// extracted by mini-css-extract-plugin
export default {"mCard":"jF-z","image":"kF-z","imageNoBackground":"lF-z","imageHasCategory":"mF-z","fullWidth":"nF-z"};